import React from 'react'
import { IoIosArrowRoundBack } from "react-icons/io";
import './BackButton.less';

const BackButton = () => {
    return (
        <>
            <span className='back-button'><IoIosArrowRoundBack size={20} /> Back</span>
        </>
    )
}

export default BackButton
